import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'ph-form-control-label',
  templateUrl: 'form-control-label.component.html',
  styleUrls: ['./form-control-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.invalid]': 'invalid()',
    '[class.disabled]': 'disabled()',
  },
})
export class FormControlLabelComponent {
  label: InputSignal<string> = input.required();
  for = input<string | undefined>(undefined);
  required: InputSignal<boolean> = input(false, { transform: coerceBooleanProperty });
  invalid: InputSignal<boolean> = input(false, { transform: coerceBooleanProperty });
  disabled: InputSignal<boolean> = input(false, { transform: coerceBooleanProperty });
}
